import { useCallback } from "react";

import { useNavigate } from "@tanstack/react-router";
import { useSidebar } from "@synthesis/shared-ui";

import { getApplicationIdFromAction, type NotificationAction } from "../notifications-panel.lib";

export const useNotificationAction = () => {
  const navigate = useNavigate();
  const { close } = useSidebar();

  return useCallback(
    (action: NotificationAction) => {
      if (action.type === "resource") {
        close();
        return;
      }

      const applicationId = action.target?.requestId ?? getApplicationIdFromAction(action);
      if (!applicationId) {
        close();
        return;
      }

      close();
      void navigate({
        to: "/applications/$id",
        params: { id: applicationId },
        search: { tab: action.target?.tab },
        // A fresh history state makes repeated actions to the same URL observable.
        state: (previous) => ({ ...previous, notificationNavigationId: `${Date.now()}-${Math.random()}` }),
      });
    },
    [close, navigate],
  );
};
